import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "dark", "color"];

var _defs;

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
import { SIZES } from '../helper';
import { useDeprecated } from '../hooks';
const rotate = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
const Root = styled.span.withConfig({
  displayName: "Spinner__Root",
  componentId: "sc-jr2shg-0"
})(["", " display:inline-block;will-change:transform;width:32px;min-width:32px;height:32px;min-height:32px overflow:hidden;padding:4px;animation:", " 1s linear infinite;", " ", ""], ScopedCssBaseline, rotate, _ref => {
  let {
    size
  } = _ref;
  return size === SIZES.SM && css(["width:24px;min-width:24px;height:24px;min-height:24px;padding:3px;"]);
}, _ref2 => {
  let {
    size
  } = _ref2;
  return size === SIZES.LG && css(["width:48px;min-width:48px;height:48px;min-heigth:48px;padding:6px;"]);
});
const Base = styled(_ref3 => {
  let {
    dark,
    color: defaultColor
  } = _ref3;
  const color = defaultColor ? defaultColor : dark ? 'var(--neutral-surface)' : 'var(--primary-surface-high-emphasis)';
  return /*#__PURE__*/React.createElement("svg", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "var(--neutral-surface)",
    stopOpacity: "0.5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "var(--neutral-surface)",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "var(--neutral-surface)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "var(--neutral-surface)",
    stopOpacity: "0.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "175",
    x2: "25",
    y1: "100",
    y2: "100",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "25",
    x2: "175",
    y1: "100",
    y2: "100",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1.4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M100 0A100 100 0 000 100h25a75 75 0 0175-75 75 75 0 0175 75h25A100 100 0 00100 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M0 100a100 100 0 00100 100 100 100 0 00100-100h-25a75 75 0 01-75 75 75 75 0 01-75-75z"
  }))))), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M0 0h200v200H0z",
    mask: "url(#e)"
  }));
}).withConfig({
  displayName: "Spinner__Base",
  componentId: "sc-jr2shg-1"
})([""]);
const Spinner = /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
    size,
    dark,
    color
  } = _ref4,
      rest = _objectWithoutPropertiesLoose(_ref4, _excluded);

  useDeprecated({
    dark
  });
  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    ref: ref,
    size: size,
    role: "status",
    "aria-label": "Loading"
  }), /*#__PURE__*/React.createElement(Base, {
    dark: dark,
    color: color
  }));
});
Spinner.displayName = 'Spinner';
Spinner.Style = Root;
Spinner.sizes = {
  sm: SIZES.SM,
  md: SIZES.MD,
  lg: SIZES.LG
};
Spinner.defaultProps = {
  size: Spinner.sizes.md,
  dark: false,
  color: null
};
process.env.NODE_ENV !== "production" ? Spinner.propTypes = {
  /**
   * Sets the size.
   */
  size: PropTypes.oneOf([Spinner.sizes.sm, Spinner.sizes.md, Spinner.sizes.lg]),

  /**
   * Sets the color. Use the Tangram CSS variables.
   *
   * @example
   * <Spinner color="var(--neutral-surface)" />
   *
   */
  color: PropTypes.string,

  /**
   * @deprecated
   */
  dark: PropTypes.bool
} : void 0;
export default Spinner;